module.exports = __webpack_public_path__ + "img/V39.3e0f49f0.jpg";